import { JuridicoFacilTypes } from './types';

export const get_data_painel = () => ({
  types: [
    JuridicoFacilTypes.GET_INDEX_REQUEST,
    JuridicoFacilTypes.GET_INDEX_SUCCESS,
    JuridicoFacilTypes.GET_INDEX_FAILURE,
  ],
  promise: (client: any) => client.get('/get_data_painel'),
});

// `fonte` distingue as duas origens do acervo: o id sozinho é ambíguo, porque
// as tabelas do acervo curado e do extrator JusBrasil têm faixas de id que se
// sobrepõem. Ausente = acervo curado, que é o comportamento de sempre.
export const consult = (id: string, fonte?: string) => ({
  types: [
    JuridicoFacilTypes.GET_CONSULT_REQUEST,
    JuridicoFacilTypes.GET_CONSULT_SUCCESS,
    JuridicoFacilTypes.GET_CONSULT_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/juridico_facil/consult/${id}${fonte ? `?fonte=${fonte}` : ''}`),
});

export const get_tipos = (id: string, page = 1) => ({
  types: [
    JuridicoFacilTypes.GET_TIPOS_REQUEST,
    JuridicoFacilTypes.GET_TIPOS_SUCCESS,
    JuridicoFacilTypes.GET_TIPOS_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/tipos/get_tipos?id=${id}&page=${page}`),
});

export const type = (id: number) => ({
  types: [
    JuridicoFacilTypes.TYPE_ID_REQUEST,
    JuridicoFacilTypes.TYPE_ID_SUCCESS,
    JuridicoFacilTypes.TYPE_ID_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/tipos/tipos_new/${id}`),
});

export const get_area = (id: string, page = 1) => ({
  types: [
    JuridicoFacilTypes.GET_AREAS_REQUEST,
    JuridicoFacilTypes.GET_AREAS_SUCCESS,
    JuridicoFacilTypes.GET_AREAS_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/areas/get_areas/?id=${id}&page=${page}`),
});

export const areas_temas = (id: string) => ({
  types: [
    JuridicoFacilTypes.AREAS_TEMAS_REQUEST,
    JuridicoFacilTypes.AREAS_TEMAS_SUCCESS,
    JuridicoFacilTypes.AREAS_TEMAS_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/areas/temas/${id}`),
});

export const areas_list_subtopics = (id: string) => ({
  types: [
    JuridicoFacilTypes.GET_AREAS_SUBTOPICS_REQUEST,
    JuridicoFacilTypes.GET_AREAS_SUBTOPICS_SUCCESS,
    JuridicoFacilTypes.GET_AREAS_SUBTOPICS_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/areas/subtemas/${id}`),
});

export const list_subtopics = (id: string) => ({
  types: [
    JuridicoFacilTypes.GET_LIST_SUBTOPICS_REQUEST,
    JuridicoFacilTypes.GET_LIST_SUBTOPICS_SUCCESS,
    JuridicoFacilTypes.GET_LIST_SUBTOPICS_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/temas/listar_subtemas/${id}`),
});

export const get_themes = (id: string, page = 1) => ({
  types: [
    JuridicoFacilTypes.GET_THEMES_REQUEST,
    JuridicoFacilTypes.GET_THEMES_SUCCESS,
    JuridicoFacilTypes.GET_THEMES_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/temas/get_temas/?id=${id}&page=${page}`),
});

export const search_type = (params: object, page: number) => ({
  types: [
    JuridicoFacilTypes.SEARCH_REQUEST,
    JuridicoFacilTypes.SEARCH_SUCCESS,
    JuridicoFacilTypes.SEARCH_FAILURE,
  ],
  promise: (client: any) => client.get(`/juridico_facil/search_new?page=${page}`, { params }),
});

export const legislation = () => ({
  types: [
    JuridicoFacilTypes.LEGISLATION_REQUEST,
    JuridicoFacilTypes.LEGISLATION_SUCCESS,
    JuridicoFacilTypes.LEGISLATION_FAILURE,
  ],
  promise: (client: any) => client.get(`/legislation`),
});

export const law = (id: string) => ({
  types: [
    JuridicoFacilTypes.LAW_REQUEST,
    JuridicoFacilTypes.LAW_SUCCESS,
    JuridicoFacilTypes.LAW_FAILURE,
  ],
  promise: (client: any) => client.get(`/legislation/law/${id}`),
});

export const search_law = (params: object, page: number) => ({
  types: [
    JuridicoFacilTypes.SEARCH_LAW_REQUEST,
    JuridicoFacilTypes.SEARCH_LAW_SUCCESS,
    JuridicoFacilTypes.SEARCH_LAW_FAILURE,
  ],
  promise: (client: any) => client.get(`/legislation/show_new?page=${page}`, { params }),
});
